import { api } from './client';
import type { Envelope } from './types';

export interface SettlementTransfer {
  id: string;
  fromUserId: string;
  toUserId: string;
  amount: number;
  status: 'PENDING' | 'COMPLETED';
  completedAt: string | null;
  completedByUserId: string | null;
}

export interface PerUserNet {
  userId: string;
  paid: number;
  owed: number;
  net: number;
}

export interface SettlementView {
  id: string;
  meetingId: string;
  status: string;
  totalAmount: number;
  participantCount: number;
  calculatedAt: string | null;
  startedAt: string | null;
  completedAt: string | null;
  perUser: PerUserNet[];
  transfers: SettlementTransfer[];
}

export async function getSettlement(meetingId: string) {
  const { data } = await api.get<Envelope<SettlementView>>(`/meetings/${meetingId}/settlement`);
  return data.data;
}

export async function recalculate(meetingId: string) {
  const { data } = await api.post<Envelope<SettlementView>>(
    `/meetings/${meetingId}/settlement/recalculate`,
  );
  return data.data;
}

export async function completeTransfer(transferId: string, completed: boolean) {
  await api.patch(`/settlement-transfers/${transferId}/complete`, { completed });
}

export async function closeSettlement(meetingId: string) {
  await api.post(`/meetings/${meetingId}/settlement/close`);
}
